import { createNamespacedHelpers } from 'vuex';
import showToast from '@/util/toast';

import MultipleLanguage from '@/components/shared/MultipleLanguage/MultipleLanguage.vue';

const authMapper = createNamespacedHelpers('global/auth');
const globalMapper = createNamespacedHelpers('global');
const modelMapper = createNamespacedHelpers('detector/model');

export default {
	name: 'Signup',

	components: {
		MultipleLanguage,
	},

	computed: {
		PLACEHOLDER() {
			return {
				username: this.$t('username'),
				password: this.$t('password'),
				confirm: this.$t('confirmPassword'),
				email: this.$t('email'),
			};
		},
	},

	data() {
		return {
			USERNAME_RULES: 'usernameSignupRequired',
			PASSWORD_RULES:
				'passwordSignupRequired|minPasswordLength:8|maxPasswordLength:16|atleastLowercase|atleastUppercase|atleastNumber|containsAtleastOneSpecialChar|notContainsSpace',
			username: {
				value: '',
				valid: false,
			},
			email: {
				value: '',
				valid: false,
			},
			password: {
				value: '',
				valid: true,
			},
			confirmPassword: {
				value: '',
				valid: true,
			},

			isShowPassword: false,
			isShowConfirmPassword: false,
			// pageTitle: this.$t("signup"),
			autoGeneratePasswordChecked: false,
		};
	},

	mounted() {},

	methods: {
		...authMapper.mapActions(['signup', 'removeUser']),
		...globalMapper.mapActions(['setSpinner']),
		...modelMapper.mapActions(['addModelDefault']),

		async onSignupButtonClick() {
			this.$refs.formValidator.validate().then(async (success) => {
				if (success) {
					this.setSpinner(true);
					let newUserId = null;

					// Add model default for user
					try {
						const addModelResponse = await this.addModelDefault({
							username: this.username.value,
							password: this.password.value,
							email: this.email.value,
						});
						newUserId = addModelResponse.data?.user_id;
					} catch (error) {
						let errorType = error.response?.data?.error;
						let message = this.$t('addDefaultModelFail');

						if (errorType === 'username_exist') {
							message = `${this.username.value} ${this.$t('existUsername')} ${this.$t(
								'chooseAnother'
							)} `;
						} else if (errorType === 'email_exist') {
							message = `${this.email.value} ${this.$t('existEmail')} ${this.$t(
								'chooseAnotherEmail'
							)} `;
						}

						showToast({
							vueInstance: this,
							type: 'danger',
							message: message,
						});

						this.setSpinner(false);
						return;
					}

					// Signup after add model default success
					try {
						const signupResponse = await this.signup({
							user_name: this.username.value,
							password: this.password.value,
							email: this.email.value,
							given_name: this.username.value,
							family_name: this.username.value,
						});
						showToast({
							vueInstance: this,
							type: 'success',
							message: this.$t('succesSignup'),
						});

						localStorage.setItem('usernameSignup', this.username.value);
						this.$router.push('/login').catch(() => {});
					} catch (error) {
						let errorMessage = ``;
						let errorType = error.response?.data?.error;
						if (errorType === 'username_exist') {
							errorMessage = `${this.username.value} ${this.$t(
								'existUsername'
							)} ${this.$t('chooseAnother')} `;
						} else if (errorType === 'email_exist') {
							errorMessage = `${this.email.value} ${this.$t('existEmail')} ${this.$t(
								'chooseAnotherEmail'
							)} `;
						} else {
							errorMessage = `${this.$t('failSignup')} ${errorType}`;
						}

						// Remove user record mongodb if signup cognito fail
						try {
							const removeUserResponse = await this.removeUser({ userId: newUserId });
						} catch (error) {
							showToast({
								vueInstance: this,
								type: 'danger',
								message: error.response?.data?.error,
							});
						}

						showToast({
							vueInstance: this,
							type: 'danger',
							message: errorMessage,
						});
						this.setSpinner(false);
						return;
					}
					this.setSpinner(false);
				}
			});
		},

		switchLanguage(language) {
			this.$i18n.locale = language;
			// re-generate validation messages
			this.$refs.formValidator.validate();
		},
		onClickLoginBtn() {
			this.$router.push('/login').catch(() => {});
		},

		togglePassword() {
			this.isShowPassword = !this.isShowPassword;
		},

		toggleConfirmPassword() {
			this.isShowConfirmPassword = !this.isShowConfirmPassword;
		},

		// generate password automatically
		randomString(length, chars) {
			let mask = '';
			if (chars.indexOf('a') > -1) mask += 'abcdefghijklmnopqrstuvwxyz';
			if (chars.indexOf('A') > -1) mask += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
			if (chars.indexOf('#') > -1) mask += '012345678901234567890123456789';
			if (chars.indexOf('!') > -1) mask += '~`!@#$%^&*()_+-={}[]:";\'<>?,./|\\';

			let result = '';
			for (let i = length; i > 0; --i)
				result += mask[Math.floor(Math.random() * mask.length)];
			return result;
		},
	},

	watch: {
		autoGeneratePasswordChecked: function (value) {
			if (value === true) {
				this.password.value = this.randomString(16, '#aA!');
			}
		},
	},
};
